import $ from 'jquery';
import Immutable from 'immutable';
import { View, Model } from 'backbone';
import leftPanelState from "LeftPanelStateService";

import utils from '../../service/util/Util.js';
import eventBus from 'EventBus.js';
import factoryService from 'FactoryService.js';
import dragDropService from 'DragDropService.js';
import constants from 'Constants.js';
import focusController from 'FocusController.js';
import listService from 'ListService.js';
import geometryService from 'GeometryService.js';
import pageInstanceFactory from 'PageInstanceFactory.js';
import pageSyncService from 'PageSyncService.js';
import viewManagerService from 'ViewManagerService';
import template from 'form/page.ejs';
import themeService from 'ThemeService.js';
import restService from 'RestService.js';
import fabric from 'fabric.js/dist/fabric.require.js';

const SILENT = constants.MODEL_SILENT;

//==========================================================================================
// A BackBone view of a PerfectForms layout page. Contains grid, and multi-select logic.
// Lou Mauget, December 16, 2015
//==========================================================================================
class PageView extends View {
    pageInstanceView;

    initialize(opts) {
        this.options = opts || {};

        // Hold id of the top page/canvas overlay rectangle, not the background grid canvas
        this.canvasId = constants.PAGESEL_ID;
        this.id = this.model.get('id');
        this.el = '#aForm';
        this.gridColorLineForImage = null;

        if(!this.model.get('zIndex')){
            this.model.set('zIndex',constants.CANVAS_Z_INDEX, SILENT);
        }


        // Initial default empty view .. or existing view if we're re-caled from a mode swtich
        this.pageInstanceView = pageInstanceFactory.createView('page_instance');

        // Copy over size from desktop if exists, this happens when coming from Behaviors / Workflow mode.
        if (listService.currentForm) {
            if (listService.currentForm.model.attributes.deviceDesktop) {
                var width = listService.currentForm.model.attributes.deviceDesktop.formWidth;
                var height = listService.currentForm.model.attributes.deviceDesktop.formHeight;

                if (width) {
                    this.model.set('width', width, SILENT);
                    listService.currentForm.model.attributes.formWidth = width;
                }
                if (height) {
                    this.model.set('height', height, SILENT);
                    listService.currentForm.model.attributes.formHeight = height;
                }
            }
        }

        this.initCanvas();

        // prevent multiple event subscriptions
        //if (!listService.currentPageId || listService.noPages || listService.loading) {
        this.stopListening();

        this.listenTo(eventBus, 'selectPage', this.selectPage);

        this.listenTo(eventBus, 'formWidthSet', this.setPageWidth);
        this.listenTo(eventBus, 'formHeightSet', this.setPageHeight);
        this.listenTo(eventBus, 'formSizeSet', this.setPageSize);
        this.listenTo(eventBus, 'gridWidthSet', this.setGridWidth);
        this.listenTo(eventBus, 'gridHeightSet', this.setGridHeight);
        this.listenTo(eventBus, 'gridSizeSet', this.setGridSize);
        this.listenTo(eventBus, 'dropShadowSet', this.setDropShadow);
        this.listenTo(eventBus, 'pageRedraw', this.redrawPage);
        this.listenTo(eventBus, 'hideCanvas', this.hideCanvas);
        this.listenTo(eventBus, 'showCanvas', this.showCanvas);

        this.listenTo(eventBus, 'frameWidthSet', this.setFrame);
        this.listenTo(eventBus, 'showFrameSet', this.setFrame);
        this.listenTo(eventBus, 'frameColorSet', this.setFrame);
        this.listenTo(eventBus, 'roundCornersSet', this.setFrame);
        //}  

        return this;
    }
    // DRY. Maybe refactor these props to a common place? These duplicated in MobileDragDropService.js

    // DRY. Maybe refactor these props to a common place? These duplicated in MobileDragDropService.js
    //==========================================================================================
    // Property: Perfect Forms canvas page position within DOM window
    //==========================================================================================
    get pagePos() {
        const offset = $(this.canvasId).offset();
        return {
            top: offset.top - $(window).scrollTop(),
            left: offset.left - $(window).scrollLeft()
        };
    }

    get objPos() {
        const canvasGroupId = this.objectID + ' .group-canvas';
        let offset = $(canvasGroupId).offset();
        if  (!offset) { offset = { top: 0, left: 0} }
        return {
            top: offset.top - $(window).scrollTop(),
            left: offset.left - $(window).scrollLeft()
        };
    }

    //==========================================================================================
    // Property: Perfect Forms canvas page width and height
    //==========================================================================================
    get pageDim() {
        return {
            width: $(this.canvasId).width(),
            height: $(this.canvasId).height()
        };
    }


    //==========================================================================================
    // Property: Perfect Forms canvas page rectangle in offset coordinates compensated for
    // window scroll position.
    //==========================================================================================
    get pageRect() {
        return {
            top: this.pagePos.top,
            left: this.pagePos.left,
            height: this.pageDim.height,
            width: this.pageDim.width
        };
    }

    //==========================================================================
    // Resets content of the transparent overlay canvas.
    // (that canvas is also the  drop listener)
    //==========================================================================
    clearCanvas() {
        this.ctx2.clearRect(0, 0, this.dim.width, this.dim.height);
        this._drawGridForId(constants.PAGESEL_ID);
    }

    clearCanvasGroup() {
        this.ctx3.clearRect(0, 0, this.dim.width, this.dim.height);
    }

    //==========================================================================
    // Draws the visual drag rectangle on the overlay canvas (#aPageSel).
    // SE corner is the canonical mouse position. We'll flip it if not.
    //==========================================================================
    drawRect(ctx) {

        if (!this.selectRect) {
            return;
        }

        listService.isDrawingMultiSelection = true;

        const sr = this.selectRect;
        this.clearCanvas();

        ctx.beginPath();
        ctx.fillStyle = 'rgba( 200, 200, 200, 0.45 )';
        ctx.fillRect(sr.left, sr.top, sr.width, sr.height);
        ctx.stroke();

        ctx.closePath();
    }

    drawRectGroup(ctx) {
        
        if (!this.selectRect) {
            return;
        }

        listService.isDrawingMultiSelection = true;

        const sr = this.selectRect;

        this.clearCanvasGroup();

        ctx.beginPath();
        ctx.fillStyle = 'rgba( 200, 200, 200, 0.45 )';
        ctx.fillRect(sr.left, sr.top, sr.width, sr.height);
        ctx.stroke();

        ctx.closePath();
    }

    //==========================================================================
    // Updates stored multi-selection rectangle: mouse down point (NW),
    // current mouse position (SE)
    //==========================================================================
    updateSelectionRect(ev, rect) {

        if (rect) {
            // Origin is relative to document object, not the canvas
            rect.width = ev.originalEvent.pageX - this.pagePos.left - $(window).scrollLeft() - rect.left;
            rect.height = ev.originalEvent.pageY - this.pagePos.top - $(window).scrollTop() - rect.top;
        }

        return rect;
    }

    updateSelectionRectGroup(ev, rect) {
        if (rect) {
            // Origin is relative to document object, not the canvas
            rect.width = ev.originalEvent.pageX - this.objPos.left - $(window).scrollLeft() - rect.left;
            rect.height = ev.originalEvent.pageY - this.objPos.top - $(window).scrollTop() - rect.top;
        }
        return rect;
    }

    //==========================================================================
    // A new control instance may be marked. Unmark current control.
    //==========================================================================
    resetSelectedMark() {
        const focusId = listService.currentId;
        const resetAll = false,
            makeMark = false;
        focusController.markControl(focusId, makeMark, resetAll);
    }


    //==========================================================================
    // Select all elements crossed by selection rectangle.
    //==========================================================================
    doMultiSelect(srp) {

        // "normalize" select rectangle if origin is at east side of rectangle
        const sr = (function normalizeRect(rn) {
            const r = _.clone(rn);

            r.left = r.width < 0 ? r.left + r.width : r.left;
            r.top = r.height < 0 ? r.top + r.height : r.top;

            r.width = Math.abs(r.width);
            r.height = Math.abs(r.height);

            return r;
        })(srp);

        // Select rectangles in-play. Skip the form.

        listService.getControlsByCurrentPage()
            .forEach((v, domId) => {
                const $domId = $(constants.ID_SEL + domId);
                const offset = $domId.offset();
                if (offset) {
                    const controlRect = {
                        left: offset.left - this.pagePos.left - $(window).scrollLeft(),
                        top: offset.top - this.pagePos.top - $(window).scrollTop(),
                        width: $domId.width(),
                        height: $domId.height()
                    };
                    if (geometryService.rect1OverlapsRect2(sr, controlRect)) {
                        // Select domID control; don't deselect others
                        focusController.selectionRectangle(domId, true, false);
                        //we skip children of groups
                        if (!v._groupId){
                            listService.addToSelected(domId);
                        }
                    }
                }
            });

        const currentSize = listService.selectedCount;
        utils.validateMenuItems(currentSize);

        if (currentSize > 1) {
            viewManagerService.renderLayoutPropertyTabs(new Model(), {multipleSelected: true});
        } else {
            const obj = listService.selected.first();
            if (obj) {
                viewManagerService.renderLayoutPropertyTabs(obj.model);

                const idProp = obj.model.get("id");
                const objProp = listService.getObject(idProp);
                const oName = objProp.model.get("name");
                $('.rail-header-text').text(oName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
                $('.rail-header-text').prop('title', oName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
                eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, 'OBJECT', idProp);
            }
        }

        listService.isDrawingMultiSelection = false;
    }

    doMultiSelectGroup(srp,id) {

        // "normalize" select rectangle if origin is at east side of rectangle
        const sr = (function normalizeRect(rn) {
            const r = _.clone(rn);

            r.left = r.width < 0 ? r.left + r.width : r.left;
            r.top = r.height < 0 ? r.top + r.height : r.top;

            r.width = Math.abs(r.width);
            r.height = Math.abs(r.height);

            return r;
        })(srp);

        // Select rectangles in-play. Skip the form.

        listService.objectList
            .filter((v, domId) => domId !== id && domId !== constants.FORM_RAW_ID )
            .forEach((v, domId) => {
                const $domId = $(constants.ID_SEL + domId);
                const offset = $domId.offset();
                if (offset) {
                    const controlRect = {
                        left: offset.left - this.objPos.left - $(window).scrollLeft(),
                        top: offset.top - this.objPos.top - $(window).scrollTop(),
                        width: $domId.width(),
                        height: $domId.height()
                    };
                    if (geometryService.rect1OverlapsRect2(sr, controlRect)) {
                        //we add only children of the selected group
                        let viewObj = listService.getObject(domId);
                        if (viewObj._groupId === id){
                            // Select domID control; don't deselect others
                            focusController.selectionRectangle(domId, true, false);
                            listService.addToSelected(domId);
                        }
                    }
                }
            });

        const currentSize = listService.selectedCount;
        utils.validateMenuItems(currentSize);

        if (currentSize > 1) {
            viewManagerService.renderLayoutPropertyTabs(new Model(), {multipleSelected: true});
        } else {
            const obj = listService.selected.first();
            if (obj) {
                viewManagerService.renderLayoutPropertyTabs(obj.model);

                const idProp = obj.model.get("id");
                const objProp = listService.getObject(idProp);
                const oName = objProp.model.get("name");
                $('.rail-header-text').text(oName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
                $('.rail-header-text').prop('title', oName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
                eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, 'OBJECT', idProp);
            }
        }

        listService.isDrawingMultiSelection = false;

    }

    //==========================================================
    // Clear multi-select, visually, and its backing list
    //==========================================================
    clearSelections() {

        const oldViews = listService.selected.map((view, domId) => view);

        listService.previousSelected = oldViews;

        listService.selected.forEach((v, domId) => {
            focusController.selectionRectangle(domId, false);
        });

        /* // #lem We don't do the marking today. Edit-in-place handles it during an edit cycle.
        // Unmarking element when it loses its focus.
        if (!listService.isCanvasSelected) {
            let element = $(`#${listService.currentId}`).find(`.pf-control-core`).get(0);
            utils.unMarkText(element, listService.currentId);
        }
        */

        listService.clearSelected();
    }

    //==========================================================
    // Detect right-click or ctrl-left-click
    //==========================================================
    isRightClick(ev) {
        // TODO Test IE9, IE10, MS Edge
        return ev.which === 3;
    }

    //======================================================================
    // Wrapper function for multi-selection drag-box implementation
    // Accepts page selection canvasID (e.g. #aPageSel)
    //======================================================================
    listenForMultiSelection(canvasId) {
        // Handles mouse down by starting listeners for move, release, and leave.
        // ==> Draws the multi-selection tracking rectangle <===
        // Uses focusController to handle any resulting selection.
        $(canvasId)
            .off(constants.EV_MOUSEDOWN);
        $(canvasId)
            .on(constants.EV_MOUSEDOWN, (ev) => {
                ev.stopPropagation();
                this.mouseDown(ev);
            });

        //Handle mouse down only when we click inside a group
        //==> Draws the multi-selection tracking rectangle <===
        $(constants.PAGE_ID)
            .off(constants.EV_MOUSEDOWN, constants.INSTANCE_CORE_CLASS);
        $(constants.PAGE_ID)
            .on(constants.EV_MOUSEDOWN, constants.INSTANCE_CORE_CLASS, (ev) => {
                    ev.stopPropagation();
                    this.mouseDownGroup(ev);
            });
    }

    mouseDownGroup(ev){
        listService.isFromMultSelectionGroup = false;
        this.objectID = constants.ID_SEL + ev.currentTarget.parentElement.id;
        this.mouseDownGroupId = ev.currentTarget.parentElement.id;

        const canvas2Id = this.canvasId;
        let c2 = $(canvas2Id).get(0);
        this.ctx3 = c2.getContext("2d");
        let canvasGroupId = null;
        if(ev.currentTarget.parentElement.id){
            canvasGroupId = constants.ID_SEL + ev.currentTarget.parentElement.id + ' .group-canvas';
            let c2 = $(canvasGroupId).get(0);
            if (c2) {
                this.ctx3 = c2.getContext("2d") ;
            }
        }

        if( utils.isTrue($(this.objectID).attr('draggable')) ){
            return;
        }

        // Don't allow entering again in the event, if already mouse down
        if (this.isMouseDownGroup) {
            return;
        }

        // Cull context menu clicks
        if (this.isRightClick(ev)) {
            listService.currentId = 'canvas';
            return;
        }

        this.isMouseDownGroup = true;

        delete this.selectRect;

        this.selectRect = {
            left: ev.originalEvent.pageX - this.objPos.left - $(window).scrollLeft(),
            top: ev.originalEvent.pageY - this.objPos.top - $(window).scrollTop(),
            width: 0,
            height: 0
        };

        // PF-1218 -- Deselect only if shift key, cntrl key (Windows, Linux, Unix)  or meta key (Mac) NOT down,
        const isStickySelection = ev.shiftKey || ev.metaKey || ev.ctrlKey;

        if (!isStickySelection ) {

            this.clearCanvasGroup();
            this.clearSelections();
        }
        // Begin listening for mouse move and release:
        // TODO don't let control swallow mouse move and up - PF-1237

        if(ev.currentTarget.parentElement.id){
            $(canvasGroupId).off(constants.EV_MOUSEUP,this.objectID);
            $(canvasGroupId).one(constants.EV_MOUSEUP,this.objectID,  ev => {
                this.mouseUpGroup(ev,canvasGroupId);
            });

            // Listen on document level for mouse move, and only once mouse up
            /*$('.pf-control.group')
                .off(constants.EV_MOUSEMOVE);
            $('.pf-control.group')
                .on(constants.EV_MOUSEMOVE, (ev) => {
                    this.mouseMoveGroup(ev,canvasGroupId);
                });*/
            $(document)
                .off(constants.EV_MOUSEUP);
            $(document)
                .one(constants.EV_MOUSEUP,  (ev) => {
                    this.mouseUpGroup(ev,canvasGroupId);
                });
        }
    }

    mouseMoveGroup(ev, canvasGroupId ){
        //ev.stopPropagation();

        if (listService.isHandleInsideGroup) {
            //return;
        }

        if(!$(ev.target).hasClass('group-canvas')) {
            return;
        }
        $(canvasGroupId).css('cursor', 'default');
        this.selectRect = this.updateSelectionRectGroup(ev, this.selectRect);
        this.drawRectGroup(this.ctx3);
    }

    mouseUpGroup(ev, canvasGroupId){
        ev.stopPropagation();



        // #PF-1401 Cleaning any column table selection on Page Selection.
        const columnSelectedSelector=$(`#${listService.currentId}`);
        columnSelectedSelector.find('td').removeClass('column-selection');
        columnSelectedSelector.find('th').removeClass('column-selection');

        this.selectRect = this.updateSelectionRectGroup(ev, this.selectRect);

        if (this.selectRect && this.selectRect.height !== 0 && this.selectRect.width !== 0) {
            // Select any controls that intersect selectRect.
            this.doMultiSelectGroup(this.selectRect, this.mouseDownGroupId);
            listService.isFromMultSelectionGroup = true;
        }

        delete this.selectRect;
        this.clearCanvasGroup();

        // Mouse is up, allow mouse down
        this.isMouseDownGroup = false;
    }

    mouseDown(ev) {
        ev.stopPropagation();

        // Don't allow entering again in the event, if already mouse down
        if (this.isMouseDown) {
            return;
        }

        // Cull context menu clicks
        if (this.isRightClick(ev)) {
            listService.currentId = 'canvas';
            return;
        }

        this.isMouseDown = true;

        delete this.selectRect;
        this.selectRect = {
            left: ev.originalEvent.pageX - this.pagePos.left - $(window).scrollLeft(),
            top: ev.originalEvent.pageY - this.pagePos.top - $(window).scrollTop(),
            width: 0,
            height: 0
        };

        // PF-1218 -- Deselect only if shift key, cntrl key (Windows, Linux, Unix)  or meta key (Mac) NOT down,
        const isStickySelection = ev.shiftKey || ev.metaKey || ev.ctrlKey;
        if (!isStickySelection ) {
            this.clearCanvas();
            this.clearSelections();
        }

        utils.updateHelpDocumentationLink('page');

        // Begin listening for mouse move and release:
        // TODO don't let control swallow mouse move and up - PF-1237
        $(this.canvasId).one(constants.EV_MOUSEUP, ev => {
            leftPanelState.save();
            this.mouseUp(ev)
        });

        // Listen on document level for mouse move, and only once mouse up
        $(document)
            .on(constants.EV_MOUSEMOVE, (ev) => {
                this.mouseMove(ev)
            })
            .one(constants.EV_MOUSEUP, (ev) => {
                this.mouseUp(ev,true);
            })


    }

    mouseMove(ev) {

        console.log("this is another move. ");
        // Set arrow cursor. Otherwise we see text cursor during drag.
        $(this.canvasId).css('cursor', 'default');
        this.selectRect = this.updateSelectionRect(ev, this.selectRect);
        this.drawRect(this.ctx2);
    }

    mouseUp(ev, global=false) {
        ev.stopPropagation();

        // #PF-1401 Cleaning any column table selection on Page Selection.
        const columnSelectedSelector=$(`#${listService.currentId}`);
        columnSelectedSelector.find('td').removeClass('column-selection');
        columnSelectedSelector.find('th').removeClass('column-selection');

        // Remove document event mouse move
        $(document).off(constants.EV_MOUSEMOVE);

        if(this.isMouseDownGroup && utils.isTrue(this.isMouseDownGroup)){
            this.selectRect = this.updateSelectionRectGroup(ev, this.selectRect);
        }else{
            this.selectRect = this.updateSelectionRect(ev, this.selectRect);
        }

        if (this.selectRect && this.selectRect.height !== 0 && this.selectRect.width !== 0) {
            // Select any controls that intersect selectRect.
            if(this.isMouseDownGroup && utils.isTrue(this.isMouseDownGroup)){
                this.doMultiSelectGroup(this.selectRect, this.mouseDownGroupId);
            }else{
                this.doMultiSelect(this.selectRect);
            }
        } else {
            if (!global) {
                this.selectPage();
            }
        }

        delete this.selectRect;
        this.clearCanvas();

        // Mouse is up, allow mouse down
        this.isMouseDown = false;
    }


    //==========================================================================
    // Paints a grid on the visible, bottom canvas.
    //==========================================================================
    _drawGridForCtx(ctx, gridColor = '#e8e8e8') {
        // TODO: create a separate temporary canvas to draw selection
        // A user-settable page property:
        const dim = { height: this.model.attributes.height, width: this.model.attributes.width };

        let gridWidth = this.model.attributes.gridWidth;
        let gridHeight = this.model.attributes.gridHeight;
        


        if (this.gridColorLineForImage !== null)
        {
            ctx.strokeStyle =  this.gridColorLineForImage;
        }else{
            ctx.strokeStyle = gridColor;
        }

        ctx.strokeWidth = 1;

        ctx.beginPath();

        if (gridWidth > 0) {
            for (let x = gridWidth; x < dim.width; x += gridWidth) {
                ctx.moveTo(x, 0);
                ctx.lineTo(x, dim.height);
                ctx.stroke();
            }
        }

        if (gridHeight > 0) {
            for (let y = gridHeight; y < dim.height; y += gridHeight) {
                ctx.moveTo(0, y);
                ctx.lineTo(dim.width, y);
                ctx.stroke();
            }
        }
        ctx.closePath();
    }

    //==========================================================================
    // Helper to access grid canvas by DOM ID
    //==========================================================================
    _drawGridForId(canvasId, gridColor = '#dcdcdc') {
        const canvas = $(canvasId).get(0);
        this._drawGridForCtx(canvas.getContext('2d'), gridColor);
    }


    //==========================================================================
    // Paints a DIV offset from the page canvases. Peeks beneath them at the
    // SE to give a drop-shadow effect.
    //==========================================================================
    redrawDropShadow(id, value) {
        if (utils.isTrue(value)) {
            $(id).addClass('formBoxShadow');
        }
        else {
            $(id).removeClass('formBoxShadow');
        }
    }


    //==========================================================================
    // Start specialized listeners that operate outside of BackBaone.
    // They act together to implement drag/drop/focus behaviors on the page.
    //==========================================================================
    startPageListeners(canvas2Id) {
        this.mouseEvents = true;

        if (listService.mainKind !== constants.KIND_MOBILE) {
            this.listenForMultiSelection(constants.PAGESEL_ID);

            dragDropService.listenForDrop(canvas2Id);
            dragDropService.listenForFactoryDragStart(factoryService.factories);
            dragDropService.listenForDragEnd(constants.CONTENT_ID);
            dragDropService.listenForInstanceDragStart();
        }


        focusController.startControlFocusListeners($(canvas2Id));
    }

    //===============================================================================
    // The context width / height settings are the means to size an HTML5 canvas.
    //===============================================================================
    resizeCanvas(rawId, width, height) {
        const c = $(constants.ID_SEL + rawId);
        const ctx = c[0].getContext('2d');

        // set width and height
        ctx.canvas.width = width;
        ctx.canvas.height = height;
        return ctx;
    }

    //==========================================================================
    // Initializes the visible grid-canvas and a transparent overlay canvas
    // atop it. A gray offset div beneath, them becomes a drop-shadow.
    //
    // Dropped controls float above this stack.
    //==========================================================================
    initCanvas(redraw = false) {

        if (!redraw) {
            this.$el.html(template(this.model.toJSON()));
        }

        const canvas1Id = constants.PAGE_ID;   // '#aPage';
        const canvas2Id = this.canvasId;        // '#aPageSel';

        const ctx = $(canvas1Id).get(0);

        const c2 = $(canvas2Id).get(0);
        this.ctx2 = c2.getContext("2d");

        /********
         * TODO: PF-3314. this is just temporary, it is necessary to modify this depending on the right data
        ********/
        if (listService.mainKind === constants.KIND_MOBILE) { 
            this.dim = { height: 600, width: 650 };
        }
        else {
            // A user-settable page property:
            this.dim = { height: this.model.attributes.height, width: this.model.attributes.width };
        }
      

        // Draw the SHADOW offset right, and down, then draw page backgroun canvas atop it with no offset
        this.redrawDropShadow(ctx, this.model.attributes.shadow);

        this.setFrame();

        // Placing Z-Index lower value possible so controls can't be below it.
        $(canvas2Id).css({'z-index':this.model.attributes.zIndex});

        // Draw the page background canvas atop the shadow, but not offset.
        //$(canvas1Id).css({ 'left': 0, 'top': 0, 'position': 'absolute', 'border': 'solid 1px #b8b8b8' });
        //$(canvas1Id).attr(this.dim);


        $(canvas2Id).attr(this.dim);

        // Show page background or image
        this.drawPage($(ctx));

        this.ctx2.scale(1, 1);

        // Draw invisible multiselection layer
        // It will have attached drag-drop listeners.
        this.ctx2.fillStyle = 'rgba(0, 0, 0, 0.0)';
        this.ctx2.fillRect(0, 0, this.dim.width, this.dim.height);

        this._drawGridForCtx(this.ctx2);

        this.ctx2.fillRect(0, 0, this.dim.width, this.dim.height);

        if (!this.mouseEvents) {
            this.startPageListeners(canvas2Id);
        }

        return this;
    }

    setPageWidth(value) {
        // PF-2675 We need to silence this one as when sizing is changed it notifies the undoACtion from PageModel as well.
        this.model.set('width', value,{silent:true});
        listService.currentForm.model.set('formWidth', value,{silent:true});
        pageSyncService.renderCurrentPageLayout();
        this.render();
    }

    setPageHeight(value) {
      // PF-2675 We need to silence this one as when sizing is changed it notifies the undoACtion from PageModel as well.
        this.model.set('height', value,{silent:true});
        listService.currentForm.model.set('formHeight', value,{silent:true});
        pageSyncService.renderCurrentPageLayout();
        this.render();
    }

    setPageSize(width, height) {
        this.model.set('height', height);
        listService.currentForm.model.set('formHeight', height);
        this.model.set('width', width);
        listService.currentForm.model.set('formWidth', width);
        pageSyncService.renderCurrentPageLayout();
    }


    setGridWidth(value) {
        this.model.set('gridWidth', parseInt(value),{silent:true});
        listService.currentForm.model.set('gridWidth', value,{silent:true});
        pageSyncService.renderCurrentPageLayout();
        this.render()
    }

    setGridHeight(value) {
        this.model.set('gridHeight', parseInt(value),{silent:true});
        listService.currentForm.model.set('gridHeight', value,{silent:true});
        pageSyncService.renderCurrentPageLayout();
        this.render()
    }

    setGridSize(value) {
        let width = 0;
        let height = 0;
        if(value){
            width = listService.currentForm.model && listService.currentForm.model.get('gridWidth') ? parseInt(listService.currentForm.model.get('gridWidth')) : 20;
            height = listService.currentForm.model &&  listService.currentForm.model.get('gridHeight') ? parseInt(listService.currentForm.model.get('gridHeight')) : 20;
        }
        this.model.set({ 'gridWidth': width, 'gridHeight': height }, { silent: false });

        if (value) {
            this._drawGridForId(constants.PAGESEL_ID);
        }
        else {
            // Clear
                this.clearCanvas();
        }
    }

    setDropShadow(value) {
        let isShadow=utils.isTrue(value);
        this.model.set('shadow', isShadow, { silent: true });
        this.redrawDropShadow($(constants.PAGE_ID), value);
        this.render();
    }

    selectPage(event) {
        const isSearch = listService.itemSearched;
        listService._isSelectedPage = true;
        setTimeout(() => {
            var pageId = listService.currentPageId;
            var pageBread = listService.getPage(pageId);
            const pName = pageBread.model.get("name");
            $('.rail-header-text').text(pName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
            $('.rail-header-text').prop('title', pName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
            eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, 'PAGE', pageId);            
            focusController.clearAllSelected();
            const currentSize = listService.selectedCount;
            utils.validateMenuItems(currentSize);

            /*
            listService.objectList.map(view => {
                if (view.subviews) {
                    view.subviews.map(propertyView => propertyView.undelegateEvents());
                }
            });
*/

            const page = listService.getPage(listService.currentPageId);

            /*
            if (page) {
                // Defense against missing model errors during dev - won't hurt later -- logged
                try {
                    this._subviews = Immutable.Map()
                        .set('styleView', new StyleView({ model: page.model, el: $(constants.PROP_STYLE_ID) }))
                        .set('behaviorView', new BehaviorView({ model: page.model, el: $(constants.PROP_BHVR_ID) }))
                        .set('attributesView', new AttributesView({ model: page.model, el: $(constants.PROP_ATTRIBUTES_ID) }))
                        .set('settingsView', new TabSettingsView({ model: page.model, el: $(constants.PROP_SETTNGS_ID) }))
                        .set('accessView', new TabAccessView({ model: page.model, el: $(constants.PROP_ACCESS_SECTION) }));
                } catch (e) {
                    console.log(e);
                }
            }
            */

            this.delegateEvents();

            /*
            // Defense against missing model errors during dev - won't hurt later -- logged
            try {
                this._subviews.map(pview => {
                    pview.render();
                    pview.delegateEvents();
                });
            } catch (e) {
                console.log(e);
            }
            */
            viewManagerService.renderLayoutPropertyTabs(page.model);

            $('.controlSelected').removeClass('controlSelected');
            leftPanelState.restore();

            if (isSearch !== 0) {
                eventBus.trigger(constants.EV_SELECT_OBJECT, listService.currentId);
            }

            let  inputFilter= (control) => {
                return ( control.options.factoryKey === 'control_progress_bar' &&  control.pageId === listService.currentPageId );}
           let pageWithProgressBar= listService.getAllPagesByControl(inputFilter);           
           if (pageWithProgressBar.length > 0){
            pageWithProgressBar[0].controls.map( (v, k) =>{                
                v.updateProgressBar();             
            });
           }
           
            console.log(`page id ${listService.currentPageId}, selected id ${listService.currentId}`);
        }, 100);
        listService.itemSearched = 0;
    }

    setFrame() {
        const form = listService.currentForm;

        if (!form) {
            return;
        }

        const showFrame = form.model.get('frame');
        const corners = form.model.get('frameRoundCorners');
        const frameColor = form.model.get('frameColor');
        const frameSize = form.model.get('frameSize');

        const isFrameVisible = utils.isTrue(showFrame);

        let styles = {};
        if (utils.isTrue(corners) && isFrameVisible) {
            styles['-webkit-border-radius'] = '15px';
            styles['-moz-border-radius'] = '15px';
            styles['border-radius'] = '15px';
        } else {
            styles['-webkit-border-radius'] = '';
            styles['-moz-border-radius'] = '';
            styles['border-radius'] = '';
        }

        styles['border-color'] = frameColor;
        if (isFrameVisible) {
            styles['border-width'] = frameSize + 'px';
            // $(this.canvasId).css({
            //     'left': frameSize + 'px',
            //     'top': frameSize + 'px'
            // });

        }
        else {
            styles['border-width'] = '0px';
            $(this.canvasId).css({
                'left': 0,
                'top': 0
            });
        }

        // Draw a page multi-select canvas atop the canvas 1:1, but transparent.


        $('.page-background').css(styles);
    }



    // There is only one canvas for all pages
    // Copy the properties and then go back to the original values
    redrawPage(color, image, style) {
        let originalColor = this.model.get('backgroundColor');
        let originalImage = this.model.get('pageImage');
        let originalStyle = this.model.get('pageImageStyle');
        this.model.set('backgroundColor', color, SILENT);
        this.model.set('pageImage', image, SILENT);
        this.model.set('pageImageStyle', style, SILENT);
        this.initCanvas(true);
        this.model.set('backgroundColor', originalColor, SILENT);
        this.model.set('pageImage', originalImage, SILENT);
        this.model.set('pageImageStyle', originalStyle, SILENT);

        this.setFrame();
        //this.setScreenColor();
    }

    createFabricCanvas(rawCanvasId) {

        // create a wrapper around native canvas element (by id )
        listService.fcanvas = new fabric.Canvas(rawCanvasId, {
                backgroundColor: constants.BEH_BG_CLR,  // Picked from AS version
                selectionColor: 'lightgray',
                renderOnAddRemove: false,
                selectionLineWidth: 1
            }
        );

        return listService.fcanvas;

    }

    drawImage(ctx) {
        let style = this.model.get('pageImageStyle') ? this.model.get('pageImageStyle').toLowerCase() : 'center';
        let that = this;

        let img = new Image();
        img.onload = () => {
            switch (style) {
                case 'stretch':
                    ctx.css({
                        'background-image': 'url(' + img.src + ')',
                        'background-repeat': 'no-repeat',
                        'background-position': '0px 0px',
                        'background-color': 'inherit',
                        'background-size': this.dim.width + 'px ' + this.dim.height + 'px'
                    })
                    break;
                case 'tile':
                    ctx.css({
                        'background-image': 'url(' + img.src + ')',
                        'background-repeat': 'repeat',
                        'background-position': 'inherit',
                        'background-color': 'inherit',
                        'background-size': 'inherit'
                    });
                    break;
                default:
                    ctx.css({
                        'background-image': 'url(' + img.src + ')',
                        'background-repeat': 'no-repeat',
                        'background-position': 'center',
                        'background-color': 'inherit',
                        'background-size': 'inherit'
                    });
                    break;
            }
        };
        img.src = restService.getAssetURL(themeService.resolve(this.model.get('pageImage')));
    }

    hideCanvas() {
        $('#aPage').hide();
        $('#aPageSel').hide();
    }

    showCanvas() {
        $('#aPage').show();
        $('#aPageSel').show();
    }

    drawPage(ctx) {

        let width, height;
        width = this.dim.width;
        height = this.dim.height;

        /*TODO: PF-3314. this is just temporary, it is necessary to modify this depending on the right data*/
        if (listService.mainKind === constants.KIND_MOBILE) {
            ctx.addClass("mobile-page");
        }
        else {
            ctx.css({
                width: width,
                height: height
            })
        }
        

        if (themeService.resolve(this.model.get('pageImage')) &&
            themeService.resolve(this.model.get('pageImage')) !== 'null' &&
            themeService.resolve(this.model.get('pageImage')).toLowerCase() !== 'none') {
            this.gridColorLineForImage = themeService.resolve(this.model.attributes.backgroundColor);
            this.drawImage(ctx);
        } else {
            // Draw visible  page
            this.gridColorLineForImage = null;
            let pageColor = themeService.resolve(this.model.attributes.backgroundColor);
            ctx.css({
                backgroundImage: '',
                backgroundColor: pageColor
            })
        }
    }

    remove() {
        this.undelegateEvents();
        this.stopListening();
        this.off();

        if (this.pageInstanceView) {
            this.pageInstanceView.remove();
        }

        this.$el.empty();
        super.remove();
    }
}

export default PageView;
